import styled from "styled-components";
import { Tabs as ANTDTabs } from "antd";

export const ErrorText = styled.div`
    color: #f10b3c;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    padding: 2px 16px;
`;